/* @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';
import Media from 'react-media';

import type { PremiumProductCollections_Partner as Partner } from '__generated__/graphql-types';

import type UserAgent from 'js/lib/useragent';

import { useTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import type { Maybe } from 'bundles/premium-certificate/__generated__/baseContentfulTypes';
import type {
  EarnCreditFragment,
  MastertrackPartnerInformationFragment,
} from 'bundles/premium-certificate/__generated__/contentfulTypes';
import EarnCreditDesktop from 'bundles/premium-certificate/components/mastertrack/EarnCreditDesktop';
import EarnCreditMobile from 'bundles/premium-certificate/components/mastertrack/EarnCreditMobile';
import Container from 'bundles/xddp/components/shared/Container';

type Props = EarnCreditFragment & {
  partnerInformation?: MastertrackPartnerInformationFragment | null;
  certificateName?: Maybe<string>;
  certificateType?: Maybe<string>;
  partnerCatalogData?: Maybe<Partner>;
  userAgent?: UserAgent;
};

const styles: Record<string, Interpolation<Theme>> = {
  earnCreditWrapper: css`
    background-color: #dceef6;
    padding: 3rem 1.5rem;
  `,
};

const EarnCreditSection: React.FunctionComponent<Props> = (props) => {
  const theme = useTheme();
  const { stackableDestinationName, stackableDestinationUrl, certificateName, certificateType, userAgent } = props;

  if (!stackableDestinationName || !stackableDestinationUrl) {
    return null;
  }

  const certificateFullName = `${certificateName} ${certificateType}`;

  return (
    <div id="credit" data-test="EarnCreditSection" css={styles.earnCreditWrapper}>
      <Container>
        <Media query={{ maxWidth: theme.breakpoints.values.md }} defaultMatches={userAgent?.isMobileBrowser}>
          {(matches) =>
            matches ? (
              <EarnCreditMobile {...props} certificateFullName={certificateFullName} />
            ) : (
              <EarnCreditDesktop {...props} certificateFullName={certificateFullName} />
            )
          }
        </Media>
      </Container>
    </div>
  );
};

export default EarnCreditSection;
